import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as authActions from '../../../redux/auth/actions';
import { validator } from '../../../utils';
import Timer from '../../../components/timer';
import Spin from '../../../components/loading';
class SetVerificationCode extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      restorationCode: ''
    }
  }

  handleChange = event => {
    let { value } = event.target;
    if (value.length <= 5 && validator.isNumber(value))
      this.setState({ restorationCode: value });
  };

  onSubmit = () => {
    let { restorationCode } = this.state;
    this.props.checkVerificationCode(restorationCode, this.props.mobileNumber).then(() => {
      this.props.setTokens()
      this.props.changeStep(3);
    })
  };

  onPreviousClicked = () => {
    this.props.changeStep(1);
  }

  render() {
    let { error, loading, message, failed, mobileNumber } = this.props;
    let { restorationCode } = this.state;
    return (
      <>
        {
          error &&
          <div className="alert alert-danger" >
            {locales("messages.server.error")}
          </div>
        }
        {failed && <div className="alert alert-danger">{message}</div>}
        <Spin spinning={loading}>
          <div className="col-12 d-flex justify-content-center align-items-center flex-column">
            <input
              className='col-7 form-control'
              value={restorationCode}
              pattern='[0-9]*'
              onChange={this.handleChange}
              placeholder={locales('labels.enterRestorationCode')}
            />
            <div className='text-white col-12 my-2 d-flex justify-content-center align-items-center'>
              <div className='mx-1'>{locales('titles.yourEnteredPhoneNumber')}:</div>
              <div className='mx-1'>{mobileNumber}</div>
            </div>
            <Timer
              min={1}
              sec={30}
              containerClassName='col-12 d-flex justify-content-center align-items-center my-2'
              substitutionTextClassName='text-white pointer'
              timerClassName='text-white pointer'
              onSubstitution={() => this.props.sendMobileNumber(mobileNumber)}
              substitutionText={locales('titles.sendCodeAgain')}
            />
            <div className="col-12 d-flex justify-content-center align-items-center">
              <button
                className='btn btn-success w-50 mx-1'
                onClick={this.onPreviousClicked}
              >
                {locales('titles.previousStep')}
              </button>
              <button
                className='btn btn-primary w-50 mx-1'
                onClick={this.onSubmit}
                disabled={restorationCode.length !== 5}
              >
                {locales('titles.nextStep')}
              </button>
            </div>
          </div>
        </Spin>
      </>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    loading: state.authReducer.checkVerificationCodeLoading,
    message: state.authReducer.checkVerificationCodeMessage,
    failed: state.authReducer.checkVerificationCodeFailed,
    error: state.authReducer.checkVerificationCodeError,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    sendMobileNumber: mobileNumber => dispatch(authActions.sendMobileNumber(mobileNumber)),
    checkVerificationCode: (restorationCode, mobileNumber) => dispatch(authActions.checkVerificationCode(restorationCode, mobileNumber))
  }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SetVerificationCode));